import React from "react";
import { useNavigate, Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { getAuth } from "firebase/auth";

function ResumeSkills() {
  const navigate = useNavigate();
  const auth = getAuth();

  const handleStart = () => {
    if (auth.currentUser) {
      navigate("/");
    } else {
      navigate("/get-started");
    }
  };

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto" }}>

      <SEOHead
        title="Skills for Resume (Top Skills List 2026)"
        description="Discover the best skills to include on your resume. Learn which hard and soft skills recruiters look for and build a stronger resume with EmployPilot."
        canonical="https://employpilot.com/resume-skills"
      />

      <h1>Top Skills for Your Resume (2026 Guide)</h1>

      <p style={{ fontSize: "18px", color: "#555" }}>
        Choosing the right skills for your resume can make a huge difference.
        Recruiters look for candidates who clearly show their abilities and value.
      </p>

      <p style={{ fontWeight: "bold", marginTop: "15px" }}>
        The right mix of hard and soft skills can help you stand out instantly.
      </p>

      <button onClick={handleStart} style={btnPrimary}>
        Add Skills to My Resume
      </button>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Hard Skills vs Soft Skills</h2>

      <p>
        A strong resume includes both technical (hard) skills and personal (soft) skills.
      </p>

      <ul>
        <li><strong>Hard skills:</strong> Job-specific abilities like coding, data analysis, or design</li>
        <li><strong>Soft skills:</strong> Communication, teamwork, and problem-solving</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Top Hard Skills for Resume</h2>

      <ul>
        <li>✔ Data analysis</li>
        <li>✔ Project management</li>
        <li>✔ Programming (Python, JavaScript)</li>
        <li>✔ Digital marketing</li>
        <li>✔ Graphic design</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Top Soft Skills for Resume</h2>

      <ul>
        <li>✔ Communication</li>
        <li>✔ Leadership</li>
        <li>✔ Problem-solving</li>
        <li>✔ Time management</li>
        <li>✔ Adaptability</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>How to Choose the Right Skills</h2>

      <ol>
        <li>Match skills to the job description</li>
        <li>Focus on relevant strengths</li>
        <li>Include skills you can demonstrate</li>
        <li>Avoid listing too many skills</li>
      </ol>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Common Mistakes to Avoid</h2>

      <ul>
        <li>❌ Listing generic skills without proof</li>
        <li>❌ Adding too many irrelevant skills</li>
        <li>❌ Not tailoring skills to the job</li>
      </ul>

      {/* 🔥 INTERNAL LINKS */}
      <p style={{ marginTop: "20px" }}>
        Need help building your resume?{" "}
        <Link to="/ai-resume-builder">
          Use the AI Resume Builder
        </Link>
      </p>

      <p>
        Want the right format?{" "}
        <Link to="/best-resume-format">
          Learn the best resume format
        </Link>
      </p>

      <p>
        Writing your summary?{" "}
        <Link to="/resume-summary-examples">
          See resume summary examples
        </Link>
      </p>

      {/* COMMUNITY CTA */}
      <p style={{ marginTop: "30px" }}>
        Want feedback on your skills?{" "}
        <strong>Join the EmployPilot Community</strong> to get real advice and suggestions.
      </p>

      <p style={{ fontSize: "14px", color: "#777" }}>
        (Free account required)
      </p>

      <Link to="/community">
        Explore the Community
      </Link>

      {/* CTA */}
      <div style={{ marginTop: "50px", textAlign: "center" }}>
        <h2>Build a Stronger Resume Today</h2>

        <button onClick={handleStart} style={btnSuccess}>
          Get Started Now
        </button>
      </div>

      {/* FAQ SECTION */}
      <h2 style={{ marginTop: "60px" }}>
        Frequently Asked Questions
      </h2>

      <h3>What skills should I put on my resume?</h3>
      <p>
        Include a mix of hard and soft skills relevant to the job you are applying for.
      </p>

      <h3>How many skills should I list?</h3>
      <p>
        Typically 5–10 strong, relevant skills are enough to make an impact.
      </p>

      <h3>Can AI help choose resume skills?</h3>
      <p>
        Yes. AI tools like EmployPilot can suggest skills based on your experience and goals.
      </p>
<div
    style={{
      marginTop: "80px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
      borderTop: "1px solid #eee",
      paddingTop: "30px"
    }}
  >
    © 2026 EmployPilot. All Rights Reserved.

    <div style={{ marginTop: "10px" }}>
      <a href="/terms" style={{ margin: "0 10px" }}>
        Terms of Use
      </a>

      <a href="/privacy" style={{ margin: "0 10px" }}>
        Privacy Policy
      </a>

      <a href="/contact" style={{ margin: "0 10px" }}>
        Contact
      </a>
    </div>
  </div>
</div>
  );
}

const btnPrimary = {
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "12px 20px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  marginTop: "20px"
};

const btnSuccess = {
  backgroundColor: "#28a745",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer"
};

export default ResumeSkills;